{
    "cities": {
        "Warszawa": {
            "lat": 52.2297,
            "lon": 21.0122
        },
        "Kraków": {
            "lat": 50.0647,
            "lon": 19.9450
        },
        "Łódź": {
            "lat": 51.7592,
            "lon": 19.4560
        },
        "Gdańsk": {
            "lat": 54.3520,
            "lon": 18.6466
        },
        "Wrocław": {
            "lat": 51.1079,
            "lon": 17.0385
        },
        "Poznań": {
            "lat": 52.4064,
            "lon": 16.9252
        },
        "Bydgoszcz": {
            "lat": 53.1235,
            "lon": 18.0084
        },
        "Szczecin": {
            "lat": 53.4285,
            "lon": 14.5528
        },
        "Lublin": {
            "lat": 51.2465,
            "lon": 22.5684
        },
        "Białystok": {
            "lat": 53.1325,
            "lon": 23.1688
        },
        "Toruń": {
            "lat": 53.0138,
            "lon": 18.5984
        },
        "Opole": {
            "lat": 50.6751,
            "lon": 17.9213
        },
        "Kielce": {
            "lat": 50.8661,
            "lon": 20.6286
        },
        "Olsztyn": {
            "lat": 53.7784,
            "lon": 20.4801
        },
        "Gorzów": {
            "lat": 52.7368,
            "lon": 15.2288
        },
        "Katowice": {
            "lat": 50.2649,
            "lon": 19.0238
        },
        "Rzeszów": {
            "lat": 50.0412,
            "lon": 21.9991
        },
        "Zielona Góra": {
            "lat": 51.9356,
            "lon": 15.5062
        }
    },
    "sm": [
        [
            "Olsztyn",
            "Budżet",
            6817624
        ],
        [
            "Olsztyn",
            "Etaty: liczba strażników",
            44
        ],
        [
            "Olsztyn",
            "Etaty: Nieobsadzone wakaty strażników",
            13
        ],
        [
            "Olsztyn",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            4900
        ],
        [
            "Olsztyn",
            "Zgłoszenia: liczba otrzymanych",
            12407
        ],
        [
            "Olsztyn",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            5036
        ],
        [
            "Olsztyn",
            "Interwencje: liczba",
            16296
        ],
        [
            "Olsztyn",
            "Interwencje: liczba dot. PRD",
            7031
        ],
        [
            "Olsztyn",
            "Mandaty: liczba wystawionych",
            4117
        ],
        [
            "Olsztyn",
            "Pouczenia: liczba",
            4934
        ],
        [
            "Olsztyn",
            "Mandaty: wartość",
            487360
        ],
        [
            "Olsztyn",
            "Mandaty: liczba wystawionych dot. PRD",
            3189
        ],
        [
            "Olsztyn",
            "Pouczenia: liczba dot. PRD",
            3880
        ],
        [
            "Olsztyn",
            "Mandaty: wartość wystawionych dot. PRD",
            402600
        ],
        [
            "Olsztyn",
            "Blokady: liczba",
            3604
        ],
        [
            "Olsztyn",
            "Holowanie: nie-wraki łącznie",
            226
        ],
        [
            "Olsztyn",
            "Holowanie: utrudnianie ruchu",
            153
        ],
        [
            "Olsztyn",
            "Holowanie: stwarzanie zagrożenia",
            12
        ],
        [
            "Olsztyn",
            "Holowanie: DMC",
            null
        ],
        [
            "Olsztyn",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Olsztyn",
            "Holowanie: T-24",
            null
        ],
        [
            "Olsztyn",
            "Holowanie: wraki",
            61
        ],
        [
            "Olsztyn",
            "Liczba etatów ogółem",
            51
        ],
        [
            "Olsztyn",
            "Liczba samochodów",
            null
        ],
        [
            "Olsztyn",
            "Liczba rowerów",
            null
        ],
        [
            "Olsztyn",
            "Liczba koni",
            null
        ],
        [
            "Olsztyn",
            "Liczba mieszkańców",
            170225
        ],
        [
            "Białystok",
            "Czas reakcji: liczba zgłoszeń",
            1242
        ],
        [
            "Białystok",
            "Czas reakcji: liczba zamkniętych",
            23
        ],
        [
            "Białystok",
            "Czas reakcji: średni czas (dni)",
            "72.78"
        ],
        [
            "Bydgoszcz",
            "Czas reakcji: liczba zgłoszeń",
            4208
        ],
        [
            "Bydgoszcz",
            "Czas reakcji: liczba zamkniętych",
            555
        ],
        [
            "Bydgoszcz",
            "Czas reakcji: średni czas (dni)",
            "184.71"
        ],
        [
            "Gdańsk",
            "Czas reakcji: liczba zgłoszeń",
            8647
        ],
        [
            "Gdańsk",
            "Czas reakcji: liczba zamkniętych",
            3975
        ],
        [
            "Gdańsk",
            "Czas reakcji: średni czas (dni)",
            "86.09"
        ],
        [
            "Gorzów",
            "Czas reakcji: liczba zgłoszeń",
            58
        ],
        [
            "Gorzów",
            "Czas reakcji: liczba zamkniętych",
            17
        ],
        [
            "Gorzów",
            "Czas reakcji: średni czas (dni)",
            "254.25"
        ],
        [
            "Katowice",
            "Czas reakcji: liczba zgłoszeń",
            1044
        ],
        [
            "Katowice",
            "Czas reakcji: liczba zamkniętych",
            17
        ],
        [
            "Katowice",
            "Czas reakcji: średni czas (dni)",
            "90.9"
        ],
        [
            "Kielce",
            "Czas reakcji: liczba zgłoszeń",
            329
        ],
        [
            "Kielce",
            "Czas reakcji: liczba zamkniętych",
            152
        ],
        [
            "Kielce",
            "Czas reakcji: średni czas (dni)",
            "57.39"
        ],
        [
            "Kraków",
            "Czas reakcji: liczba zgłoszeń",
            3454
        ],
        [
            "Kraków",
            "Czas reakcji: liczba zamkniętych",
            902
        ],
        [
            "Kraków",
            "Czas reakcji: średni czas (dni)",
            "103.89"
        ],
        [
            "Łódź",
            "Czas reakcji: liczba zgłoszeń",
            5234
        ],
        [
            "Łódź",
            "Czas reakcji: liczba zamkniętych",
            683
        ],
        [
            "Łódź",
            "Czas reakcji: średni czas (dni)",
            "102.3"
        ],
        [
            "Lublin",
            "Czas reakcji: liczba zgłoszeń",
            220
        ],
        [
            "Lublin",
            "Czas reakcji: liczba zamkniętych",
            29
        ],
        [
            "Lublin",
            "Czas reakcji: średni czas (dni)",
            "63.23"
        ],
        [
            "Olsztyn",
            "Czas reakcji: liczba zgłoszeń",
            427
        ],
        [
            "Olsztyn",
            "Czas reakcji: liczba zamkniętych",
            67
        ],
        [
            "Olsztyn",
            "Czas reakcji: średni czas (dni)",
            "10.41"
        ],
        [
            "Opole",
            "Czas reakcji: liczba zgłoszeń",
            3023
        ],
        [
            "Opole",
            "Czas reakcji: liczba zamkniętych",
            1656
        ],
        [
            "Opole",
            "Czas reakcji: średni czas (dni)",
            "102.87"
        ],
        [
            "Poznań",
            "Czas reakcji: liczba zgłoszeń",
            9589
        ],
        [
            "Poznań",
            "Czas reakcji: liczba zamkniętych",
            518
        ],
        [
            "Poznań",
            "Czas reakcji: średni czas (dni)",
            "185.01"
        ],
        [
            "Rzeszów",
            "Czas reakcji: liczba zgłoszeń",
            176
        ],
        [
            "Rzeszów",
            "Czas reakcji: liczba zamkniętych",
            21
        ],
        [
            "Rzeszów",
            "Czas reakcji: średni czas (dni)",
            "69.53"
        ],
        [
            "Szczecin",
            "Czas reakcji: liczba zgłoszeń",
            845
        ],
        [
            "Szczecin",
            "Czas reakcji: liczba zamkniętych",
            54
        ],
        [
            "Szczecin",
            "Czas reakcji: średni czas (dni)",
            "113.65"
        ],
        [
            "Toruń",
            "Czas reakcji: liczba zgłoszeń",
            1320
        ],
        [
            "Toruń",
            "Czas reakcji: liczba zamkniętych",
            3
        ],
        [
            "Toruń",
            "Czas reakcji: średni czas (dni)",
            "50.58"
        ],
        [
            "Warszawa",
            "Czas reakcji: liczba zgłoszeń",
            58040
        ],
        [
            "Warszawa",
            "Czas reakcji: liczba zamkniętych",
            1904
        ],
        [
            "Warszawa",
            "Czas reakcji: średni czas (dni)",
            "220.11"
        ],
        [
            "Wrocław",
            "Czas reakcji: liczba zgłoszeń",
            43241
        ],
        [
            "Wrocław",
            "Czas reakcji: liczba zamkniętych",
            526
        ],
        [
            "Wrocław",
            "Czas reakcji: średni czas (dni)",
            "103.55"
        ],
        [
            "Zielona Góra",
            "Czas reakcji: liczba zgłoszeń",
            488
        ],
        [
            "Zielona Góra",
            "Czas reakcji: liczba zamkniętych",
            52
        ],
        [
            "Zielona Góra",
            "Czas reakcji: średni czas (dni)",
            "47.27"
        ],
        [
            "Białystok",
            "Policja: mandaty ogółem",
            44289
        ],
        [
            "Bydgoszcz",
            "Policja: mandaty parkowanie",
            32
        ],
        [
            "Bydgoszcz",
            "Policja: wykroczenia parkowanie",
            104
        ],
        [
            "Gdańsk",
            "Policja: mandaty ogółem",
            29080
        ],
        [
            "Gdańsk",
            "Policja: pouczenia ogółem",
            5081
        ],
        [
            "Gdańsk",
            "Policja: sąd ogółem",
            4777
        ],
        [
            "Gdańsk",
            "Policja: wykroczenia ogółem",
            38938
        ],
        [
            "Gdańsk",
            "Policja: wykroczenia parkowanie",
            958
        ],
        [
            "Gorzów",
            "Policja: mandaty ogółem",
            14990
        ],
        [
            "Gorzów",
            "Policja: mandaty parkowanie",
            224
        ],
        [
            "Gorzów",
            "Policja: pouczenia ogółem",
            2588
        ],
        [
            "Gorzów",
            "Policja: sąd ogółem",
            1129
        ],
        [
            "Gorzów",
            "Policja: wykroczenia ogółem",
            18084
        ],
        [
            "Gorzów",
            "Policja: wykroczenia parkowanie",
            234
        ],
        [
            "Katowice",
            "Policja: mandaty ogółem",
            30232
        ],
        [
            "Katowice",
            "Policja: pouczenia ogółem",
            8044
        ],
        [
            "Katowice",
            "Policja: sąd ogółem",
            2082
        ],
        [
            "Katowice",
            "Policja: wykroczenia ogółem",
            40358
        ],
        [
            "Kielce",
            "Policja: mandaty ogółem",
            12275
        ],
        [
            "Kielce",
            "Policja: pouczenia ogółem",
            16173
        ],
        [
            "Kielce",
            "Policja: sąd ogółem",
            3399
        ],
        [
            "Kielce",
            "Policja: wykroczenia ogółem",
            32770
        ],
        [
            "Lublin",
            "Policja: mandaty ogółem",
            26428
        ],
        [
            "Lublin",
            "Policja: pouczenia ogółem",
            8947
        ],
        [
            "Lublin",
            "Policja: sąd ogółem",
            2863
        ],
        [
            "Lublin",
            "Policja: wykroczenia ogółem",
            37238
        ],
        [
            "Lublin",
            "Policja: wykroczenia parkowanie",
            891
        ],
        [
            "Łódź",
            "Policja: wykroczenia parkowanie",
            1181
        ],
        [
            "Olsztyn",
            "Policja: mandaty parkowanie",
            2623
        ],
        [
            "Opole",
            "Policja: mandaty ogółem",
            4330
        ],
        [
            "Opole",
            "Policja: mandaty parkowanie",
            152
        ],
        [
            "Opole",
            "Policja: pouczenia ogółem",
            14595
        ],
        [
            "Opole",
            "Policja: sąd ogółem",
            1220
        ],
        [
            "Opole",
            "Policja: sąd parkowanie",
            7
        ],
        [
            "Opole",
            "Policja: wykroczenia parkowanie",
            233
        ],
        [
            "Poznań",
            "Policja: mandaty ogółem",
            54125
        ],
        [
            "Poznań",
            "Policja: pouczenia ogółem",
            8009
        ],
        [
            "Poznań",
            "Policja: sąd ogółem",
            3123
        ],
        [
            "Poznań",
            "Policja: wykroczenia ogółem",
            65257
        ],
        [
            "Rzeszów",
            "Policja: mandaty parkowanie",
            2722
        ],
        [
            "Rzeszów",
            "Policja: pouczenia parkowanie",
            null
        ],
        [
            "Rzeszów",
            "Policja: sąd parkowanie",
            48
        ],
        [
            "Rzeszów",
            "Policja: wykroczenia parkowanie",
            2770
        ],
        [
            "Szczecin",
            "Policja: mandaty ogółem",
            14524
        ],
        [
            "Szczecin",
            "Policja: pouczenia ogółem",
            12669
        ],
        [
            "Szczecin",
            "Policja: sąd ogółem",
            3546
        ],
        [
            "Szczecin",
            "Policja: wykroczenia ogółem",
            30739
        ],
        [
            "Szczecin",
            "Policja: wykroczenia parkowanie",
            15252
        ],
        [
            "Toruń",
            "Policja: mandaty ogółem",
            20532
        ],
        [
            "Toruń",
            "Policja: pouczenia ogółem",
            6606
        ],
        [
            "Toruń",
            "Policja: sąd ogółem",
            1024
        ],
        [
            "Toruń",
            "Policja: wykroczenia ogółem",
            28164
        ],
        [
            "Toruń",
            "Policja: wykroczenia parkowanie",
            121
        ],
        [
            "Warszawa",
            "Policja: mandaty ogółem",
            100209
        ],
        [
            "Warszawa",
            "Policja: mandaty parkowanie",
            4796
        ],
        [
            "Warszawa",
            "Policja: pouczenia ogółem",
            75629
        ],
        [
            "Warszawa",
            "Policja: pouczenia parkowanie",
            1272
        ],
        [
            "Warszawa",
            "Policja: sąd ogółem",
            6435
        ],
        [
            "Warszawa",
            "Policja: sąd parkowanie",
            415
        ],
        [
            "Warszawa",
            "Policja: wykroczenia ogółem",
            183283
        ],
        [
            "Warszawa",
            "Policja: wykroczenia parkowanie",
            29409
        ],
        [
            "Wrocław",
            "Policja: mandaty ogółem",
            21700
        ],
        [
            "Wrocław",
            "Policja: pouczenia ogółem",
            35161
        ],
        [
            "Wrocław",
            "Policja: sąd ogółem",
            4367
        ],
        [
            "Wrocław",
            "Policja: wykroczenia ogółem",
            61228
        ],
        [
            "Wrocław",
            "Policja: wykroczenia parkowanie",
            602
        ],
        [
            "Zielona Góra",
            "Policja: mandaty parkowanie",
            1761
        ],
        [
            "Kraków",
            "Policja: mandaty parkowanie",
            2169.4199999999996
        ],
        [
            "Kraków",
            "Policja: pouczenia parkowanie",
            1117.5800000000002
        ],
        [
            "Lublin",
            "Budżet",
            16052676
        ],
        [
            "Lublin",
            "Etaty: liczba strażników",
            110
        ],
        [
            "Lublin",
            "Etaty: Nieobsadzone wakaty strażników",
            10
        ],
        [
            "Lublin",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            6288
        ],
        [
            "Lublin",
            "Zgłoszenia: liczba otrzymanych",
            26694
        ],
        [
            "Lublin",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            9533
        ],
        [
            "Lublin",
            "Interwencje: liczba",
            36071
        ],
        [
            "Lublin",
            "Interwencje: liczba dot. PRD",
            17401
        ],
        [
            "Lublin",
            "Mandaty: liczba wystawionych",
            16684
        ],
        [
            "Lublin",
            "Pouczenia: liczba",
            2700
        ],
        [
            "Lublin",
            "Mandaty: wartość",
            2380570
        ],
        [
            "Lublin",
            "Mandaty: liczba wystawionych dot. PRD",
            13124
        ],
        [
            "Lublin",
            "Pouczenia: liczba dot. PRD",
            1875
        ],
        [
            "Lublin",
            "Mandaty: wartość wystawionych dot. PRD",
            1891960
        ],
        [
            "Lublin",
            "Blokady: liczba",
            8350
        ],
        [
            "Lublin",
            "Holowanie: nie-wraki łącznie",
            1180
        ],
        [
            "Lublin",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Lublin",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Lublin",
            "Holowanie: DMC",
            null
        ],
        [
            "Lublin",
            "Holowanie: niepełnosprawni",
            60
        ],
        [
            "Lublin",
            "Holowanie: T-24",
            null
        ],
        [
            "Lublin",
            "Holowanie: wraki",
            4
        ],
        [
            "Lublin",
            "Liczba etatów ogółem",
            130
        ],
        [
            "Lublin",
            "Liczba samochodów",
            18
        ],
        [
            "Lublin",
            "Liczba rowerów",
            12
        ],
        [
            "Lublin",
            "Liczba koni",
            null
        ],
        [
            "Lublin",
            "Liczba mieszkańców",
            334681
        ],
        [
            "Kielce",
            "Budżet",
            8795000
        ],
        [
            "Kielce",
            "Etaty: liczba strażników",
            71
        ],
        [
            "Kielce",
            "Etaty: Nieobsadzone wakaty strażników",
            null
        ],
        [
            "Kielce",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            5640
        ],
        [
            "Kielce",
            "Zgłoszenia: liczba otrzymanych",
            16038
        ],
        [
            "Kielce",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            7867
        ],
        [
            "Kielce",
            "Interwencje: liczba",
            25653
        ],
        [
            "Kielce",
            "Interwencje: liczba dot. PRD",
            7867
        ],
        [
            "Kielce",
            "Mandaty: liczba wystawionych",
            6731
        ],
        [
            "Kielce",
            "Pouczenia: liczba",
            3418
        ],
        [
            "Kielce",
            "Mandaty: wartość",
            740687
        ],
        [
            "Kielce",
            "Mandaty: liczba wystawionych dot. PRD",
            4519
        ],
        [
            "Kielce",
            "Pouczenia: liczba dot. PRD",
            2532
        ],
        [
            "Kielce",
            "Mandaty: wartość wystawionych dot. PRD",
            532350
        ],
        [
            "Kielce",
            "Blokady: liczba",
            5519
        ],
        [
            "Kielce",
            "Holowanie: nie-wraki łącznie",
            18
        ],
        [
            "Kielce",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Kielce",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Kielce",
            "Holowanie: DMC",
            null
        ],
        [
            "Kielce",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Kielce",
            "Holowanie: T-24",
            null
        ],
        [
            "Kielce",
            "Holowanie: wraki",
            19
        ],
        [
            "Kielce",
            "Liczba etatów ogółem",
            null
        ],
        [
            "Kielce",
            "Liczba samochodów",
            null
        ],
        [
            "Kielce",
            "Liczba rowerów",
            null
        ],
        [
            "Kielce",
            "Liczba koni",
            null
        ],
        [
            "Kielce",
            "Liczba mieszkańców",
            186838
        ],
        [
            "Rzeszów",
            "Budżet",
            6734308
        ],
        [
            "Rzeszów",
            "Etaty: liczba strażników",
            56
        ],
        [
            "Rzeszów",
            "Etaty: Nieobsadzone wakaty strażników",
            4
        ],
        [
            "Rzeszów",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            null
        ],
        [
            "Rzeszów",
            "Zgłoszenia: liczba otrzymanych",
            null
        ],
        [
            "Rzeszów",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            null
        ],
        [
            "Rzeszów",
            "Interwencje: liczba",
            null
        ],
        [
            "Rzeszów",
            "Interwencje: liczba dot. PRD",
            null
        ],
        [
            "Rzeszów",
            "Mandaty: liczba wystawionych",
            3422
        ],
        [
            "Rzeszów",
            "Pouczenia: liczba",
            3545
        ],
        [
            "Rzeszów",
            "Mandaty: wartość",
            381600
        ],
        [
            "Rzeszów",
            "Mandaty: liczba wystawionych dot. PRD",
            2759
        ],
        [
            "Rzeszów",
            "Pouczenia: liczba dot. PRD",
            2767
        ],
        [
            "Rzeszów",
            "Mandaty: wartość wystawionych dot. PRD",
            330950
        ],
        [
            "Rzeszów",
            "Blokady: liczba",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: nie-wraki łącznie",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: DMC",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: T-24",
            null
        ],
        [
            "Rzeszów",
            "Holowanie: wraki",
            null
        ],
        [
            "Rzeszów",
            "Liczba etatów ogółem",
            64
        ],
        [
            "Rzeszów",
            "Liczba samochodów",
            9
        ],
        [
            "Rzeszów",
            "Liczba rowerów",
            null
        ],
        [
            "Rzeszów",
            "Liczba koni",
            null
        ],
        [
            "Rzeszów",
            "Uwagi",
            "Mam dane z 2023. Brak odpowiedzi na 2024. Groźba wysłana 26.11"
        ],
        [
            "Rzeszów",
            "Liczba mieszkańców",
            196638
        ],
        [
            "Katowice",
            "Budżet",
            19032023
        ],
        [
            "Katowice",
            "Etaty: liczba strażników",
            125
        ],
        [
            "Katowice",
            "Etaty: Nieobsadzone wakaty strażników",
            8
        ],
        [
            "Katowice",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            5578
        ],
        [
            "Katowice",
            "Zgłoszenia: liczba otrzymanych",
            23311
        ],
        [
            "Katowice",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            12789
        ],
        [
            "Katowice",
            "Interwencje: liczba",
            38224
        ],
        [
            "Katowice",
            "Interwencje: liczba dot. PRD",
            23607
        ],
        [
            "Katowice",
            "Mandaty: liczba wystawionych",
            14680
        ],
        [
            "Katowice",
            "Pouczenia: liczba",
            2630
        ],
        [
            "Katowice",
            "Mandaty: wartość",
            1877670
        ],
        [
            "Katowice",
            "Mandaty: liczba wystawionych dot. PRD",
            11890
        ],
        [
            "Katowice",
            "Pouczenia: liczba dot. PRD",
            2413
        ],
        [
            "Katowice",
            "Mandaty: wartość wystawionych dot. PRD",
            1442010
        ],
        [
            "Katowice",
            "Blokady: liczba",
            4696
        ],
        [
            "Katowice",
            "Holowanie: nie-wraki łącznie",
            26
        ],
        [
            "Katowice",
            "Holowanie: utrudnianie ruchu",
            26
        ],
        [
            "Katowice",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Katowice",
            "Holowanie: DMC",
            null
        ],
        [
            "Katowice",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Katowice",
            "Holowanie: T-24",
            null
        ],
        [
            "Katowice",
            "Holowanie: wraki",
            84
        ],
        [
            "Katowice",
            "Liczba etatów ogółem",
            143
        ],
        [
            "Katowice",
            "Liczba samochodów",
            16
        ],
        [
            "Katowice",
            "Liczba rowerów",
            5
        ],
        [
            "Katowice",
            "Liczba koni",
            null
        ],
        [
            "Katowice",
            "Liczba mieszkańców",
            285711
        ],
        [
            "Wrocław",
            "Budżet",
            44032796
        ],
        [
            "Wrocław",
            "Etaty: liczba strażników",
            311
        ],
        [
            "Wrocław",
            "Etaty: Nieobsadzone wakaty strażników",
            66
        ],
        [
            "Wrocław",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            8163
        ],
        [
            "Wrocław",
            "Zgłoszenia: liczba otrzymanych",
            72408
        ],
        [
            "Wrocław",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            54117
        ],
        [
            "Wrocław",
            "Interwencje: liczba",
            37972
        ],
        [
            "Wrocław",
            "Interwencje: liczba dot. PRD",
            34788
        ],
        [
            "Wrocław",
            "Mandaty: liczba wystawionych",
            20482
        ],
        [
            "Wrocław",
            "Pouczenia: liczba",
            8605
        ],
        [
            "Wrocław",
            "Mandaty: wartość",
            3560710
        ],
        [
            "Wrocław",
            "Mandaty: liczba wystawionych dot. PRD",
            18380
        ],
        [
            "Wrocław",
            "Pouczenia: liczba dot. PRD",
            8030
        ],
        [
            "Wrocław",
            "Mandaty: wartość wystawionych dot. PRD",
            3165570
        ],
        [
            "Wrocław",
            "Blokady: liczba",
            610
        ],
        [
            "Wrocław",
            "Holowanie: nie-wraki łącznie",
            2915
        ],
        [
            "Wrocław",
            "Holowanie: utrudnianie ruchu",
            115
        ],
        [
            "Wrocław",
            "Holowanie: stwarzanie zagrożenia",
            70
        ],
        [
            "Wrocław",
            "Holowanie: DMC",
            null
        ],
        [
            "Wrocław",
            "Holowanie: niepełnosprawni",
            232
        ],
        [
            "Wrocław",
            "Holowanie: T-24",
            2498
        ],
        [
            "Wrocław",
            "Holowanie: wraki",
            366
        ],
        [
            "Wrocław",
            "Liczba etatów ogółem",
            null
        ],
        [
            "Wrocław",
            "Liczba samochodów",
            null
        ],
        [
            "Wrocław",
            "Liczba rowerów",
            null
        ],
        [
            "Wrocław",
            "Liczba koni",
            null
        ],
        [
            "Wrocław",
            "Liczba mieszkańców",
            672929
        ],
        [
            "Kraków",
            "Budżet",
            106269155
        ],
        [
            "Kraków",
            "Etaty: liczba strażników",
            421.75
        ],
        [
            "Kraków",
            "Etaty: Nieobsadzone wakaty strażników",
            7.5
        ],
        [
            "Kraków",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            9792
        ],
        [
            "Kraków",
            "Zgłoszenia: liczba otrzymanych",
            108420
        ],
        [
            "Kraków",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            52231
        ],
        [
            "Kraków",
            "Interwencje: liczba",
            null
        ],
        [
            "Kraków",
            "Interwencje: liczba dot. PRD",
            null
        ],
        [
            "Kraków",
            "Mandaty: liczba wystawionych",
            73303
        ],
        [
            "Kraków",
            "Pouczenia: liczba",
            64482
        ],
        [
            "Kraków",
            "Mandaty: wartość",
            9056285
        ],
        [
            "Kraków",
            "Mandaty: liczba wystawionych dot. PRD",
            42141
        ],
        [
            "Kraków",
            "Pouczenia: liczba dot. PRD",
            44046
        ],
        [
            "Kraków",
            "Mandaty: wartość wystawionych dot. PRD",
            5485085
        ],
        [
            "Kraków",
            "Blokady: liczba",
            18165
        ],
        [
            "Kraków",
            "Holowanie: nie-wraki łącznie",
            867
        ],
        [
            "Kraków",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Kraków",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Kraków",
            "Holowanie: DMC",
            null
        ],
        [
            "Kraków",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Kraków",
            "Holowanie: T-24",
            null
        ],
        [
            "Kraków",
            "Holowanie: wraki",
            536
        ],
        [
            "Kraków",
            "Liczba etatów ogółem",
            528.75
        ],
        [
            "Kraków",
            "Liczba samochodów",
            89
        ],
        [
            "Kraków",
            "Liczba rowerów",
            44
        ],
        [
            "Kraków",
            "Liczba koni",
            null
        ],
        [
            "Kraków",
            "Liczba mieszkańców",
            800653
        ],
        [
            "Białystok",
            "Budżet",
            14968677
        ],
        [
            "Białystok",
            "Etaty: liczba strażników",
            105
        ],
        [
            "Białystok",
            "Etaty: Nieobsadzone wakaty strażników",
            null
        ],
        [
            "Białystok",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            5835
        ],
        [
            "Białystok",
            "Zgłoszenia: liczba otrzymanych",
            27714
        ],
        [
            "Białystok",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            12643
        ],
        [
            "Białystok",
            "Interwencje: liczba",
            15632
        ],
        [
            "Białystok",
            "Interwencje: liczba dot. PRD",
            11361
        ],
        [
            "Białystok",
            "Mandaty: liczba wystawionych",
            6503
        ],
        [
            "Białystok",
            "Pouczenia: liczba",
            6075
        ],
        [
            "Białystok",
            "Mandaty: wartość",
            670580
        ],
        [
            "Białystok",
            "Mandaty: liczba wystawionych dot. PRD",
            4651
        ],
        [
            "Białystok",
            "Pouczenia: liczba dot. PRD",
            5367
        ],
        [
            "Białystok",
            "Mandaty: wartość wystawionych dot. PRD",
            533580
        ],
        [
            "Białystok",
            "Blokady: liczba",
            38
        ],
        [
            "Białystok",
            "Holowanie: nie-wraki łącznie",
            77
        ],
        [
            "Białystok",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Białystok",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Białystok",
            "Holowanie: DMC",
            null
        ],
        [
            "Białystok",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Białystok",
            "Holowanie: T-24",
            null
        ],
        [
            "Białystok",
            "Holowanie: wraki",
            78
        ],
        [
            "Białystok",
            "Liczba etatów ogółem",
            145
        ],
        [
            "Białystok",
            "Liczba samochodów",
            20
        ],
        [
            "Białystok",
            "Liczba rowerów",
            8
        ],
        [
            "Białystok",
            "Liczba koni",
            null
        ],
        [
            "Białystok",
            "Liczba mieszkańców",
            294242
        ],
        [
            "Bydgoszcz",
            "Budżet",
            22021328
        ],
        [
            "Bydgoszcz",
            "Etaty: liczba strażników",
            136
        ],
        [
            "Bydgoszcz",
            "Etaty: Nieobsadzone wakaty strażników",
            24.06
        ],
        [
            "Bydgoszcz",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            null
        ],
        [
            "Bydgoszcz",
            "Zgłoszenia: liczba otrzymanych",
            28340
        ],
        [
            "Bydgoszcz",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            15043
        ],
        [
            "Bydgoszcz",
            "Interwencje: liczba",
            null
        ],
        [
            "Bydgoszcz",
            "Interwencje: liczba dot. PRD",
            null
        ],
        [
            "Bydgoszcz",
            "Mandaty: liczba wystawionych",
            13087
        ],
        [
            "Bydgoszcz",
            "Pouczenia: liczba",
            5631
        ],
        [
            "Bydgoszcz",
            "Mandaty: wartość",
            1736933.55
        ],
        [
            "Bydgoszcz",
            "Mandaty: liczba wystawionych dot. PRD",
            9605
        ],
        [
            "Bydgoszcz",
            "Pouczenia: liczba dot. PRD",
            3913
        ],
        [
            "Bydgoszcz",
            "Mandaty: wartość wystawionych dot. PRD",
            1403923
        ],
        [
            "Bydgoszcz",
            "Blokady: liczba",
            5090
        ],
        [
            "Bydgoszcz",
            "Holowanie: nie-wraki łącznie",
            1135
        ],
        [
            "Bydgoszcz",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Bydgoszcz",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Bydgoszcz",
            "Holowanie: DMC",
            null
        ],
        [
            "Bydgoszcz",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Bydgoszcz",
            "Holowanie: T-24",
            null
        ],
        [
            "Bydgoszcz",
            "Holowanie: wraki",
            63
        ],
        [
            "Bydgoszcz",
            "Liczba etatów ogółem",
            null
        ],
        [
            "Bydgoszcz",
            "Liczba samochodów",
            null
        ],
        [
            "Bydgoszcz",
            "Liczba rowerów",
            null
        ],
        [
            "Bydgoszcz",
            "Liczba koni",
            null
        ],
        [
            "Bydgoszcz",
            "Liczba mieszkańców",
            337666
        ],
        [
            "Gdańsk",
            "Budżet",
            44613742
        ],
        [
            "Gdańsk",
            "Etaty: liczba strażników",
            249
        ],
        [
            "Gdańsk",
            "Etaty: Nieobsadzone wakaty strażników",
            52
        ],
        [
            "Gdańsk",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            5467
        ],
        [
            "Gdańsk",
            "Zgłoszenia: liczba otrzymanych",
            22016
        ],
        [
            "Gdańsk",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            12180
        ],
        [
            "Gdańsk",
            "Interwencje: liczba",
            "sprawozdanie"
        ],
        [
            "Gdańsk",
            "Interwencje: liczba dot. PRD",
            28371
        ],
        [
            "Gdańsk",
            "Mandaty: liczba wystawionych",
            30689
        ],
        [
            "Gdańsk",
            "Pouczenia: liczba",
            2087
        ],
        [
            "Gdańsk",
            "Mandaty: wartość",
            3298615
        ],
        [
            "Gdańsk",
            "Mandaty: liczba wystawionych dot. PRD",
            24102
        ],
        [
            "Gdańsk",
            "Pouczenia: liczba dot. PRD",
            1507
        ],
        [
            "Gdańsk",
            "Mandaty: wartość wystawionych dot. PRD",
            2822150
        ],
        [
            "Gdańsk",
            "Blokady: liczba",
            11029
        ],
        [
            "Gdańsk",
            "Holowanie: nie-wraki łącznie",
            160
        ],
        [
            "Gdańsk",
            "Holowanie: utrudnianie ruchu",
            31
        ],
        [
            "Gdańsk",
            "Holowanie: stwarzanie zagrożenia",
            5
        ],
        [
            "Gdańsk",
            "Holowanie: DMC",
            null
        ],
        [
            "Gdańsk",
            "Holowanie: niepełnosprawni",
            33
        ],
        [
            "Gdańsk",
            "Holowanie: T-24",
            91
        ],
        [
            "Gdańsk",
            "Holowanie: wraki",
            167
        ],
        [
            "Gdańsk",
            "Liczba etatów ogółem",
            314
        ],
        [
            "Gdańsk",
            "Liczba samochodów",
            34
        ],
        [
            "Gdańsk",
            "Liczba rowerów",
            15
        ],
        [
            "Gdańsk",
            "Liczba koni",
            null
        ],
        [
            "Gdańsk",
            "Liczba mieszkańców",
            486022
        ],
        [
            "Gorzów",
            "Budżet",
            2234705
        ],
        [
            "Gorzów",
            "Etaty: liczba strażników",
            17
        ],
        [
            "Gorzów",
            "Etaty: Nieobsadzone wakaty strażników",
            null
        ],
        [
            "Gorzów",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            7475
        ],
        [
            "Gorzów",
            "Zgłoszenia: liczba otrzymanych",
            1101
        ],
        [
            "Gorzów",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            815
        ],
        [
            "Gorzów",
            "Interwencje: liczba",
            9961
        ],
        [
            "Gorzów",
            "Interwencje: liczba dot. PRD",
            4516
        ],
        [
            "Gorzów",
            "Mandaty: liczba wystawionych",
            2075
        ],
        [
            "Gorzów",
            "Pouczenia: liczba",
            5445
        ],
        [
            "Gorzów",
            "Mandaty: wartość",
            266114.5
        ],
        [
            "Gorzów",
            "Mandaty: liczba wystawionych dot. PRD",
            1489
        ],
        [
            "Gorzów",
            "Pouczenia: liczba dot. PRD",
            2979
        ],
        [
            "Gorzów",
            "Mandaty: wartość wystawionych dot. PRD",
            186700
        ],
        [
            "Gorzów",
            "Blokady: liczba",
            null
        ],
        [
            "Gorzów",
            "Holowanie: nie-wraki łącznie",
            248
        ],
        [
            "Gorzów",
            "Holowanie: utrudnianie ruchu",
            15
        ],
        [
            "Gorzów",
            "Holowanie: stwarzanie zagrożenia",
            18
        ],
        [
            "Gorzów",
            "Holowanie: DMC",
            11
        ],
        [
            "Gorzów",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Gorzów",
            "Holowanie: T-24",
            204
        ],
        [
            "Gorzów",
            "Holowanie: wraki",
            64
        ],
        [
            "Gorzów",
            "Liczba etatów ogółem",
            19
        ],
        [
            "Gorzów",
            "Liczba samochodów",
            3
        ],
        [
            "Gorzów",
            "Liczba rowerów",
            5
        ],
        [
            "Gorzów",
            "Liczba koni",
            null
        ],
        [
            "Gorzów",
            "Liczba mieszkańców",
            119964
        ],
        [
            "Łódź",
            "Budżet",
            55873502
        ],
        [
            "Łódź",
            "Etaty: liczba strażników",
            333
        ],
        [
            "Łódź",
            "Etaty: Nieobsadzone wakaty strażników",
            66
        ],
        [
            "Łódź",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            6274
        ],
        [
            "Łódź",
            "Zgłoszenia: liczba otrzymanych",
            40866
        ],
        [
            "Łódź",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            20264
        ],
        [
            "Łódź",
            "Interwencje: liczba",
            42372
        ],
        [
            "Łódź",
            "Interwencje: liczba dot. PRD",
            17867
        ],
        [
            "Łódź",
            "Mandaty: liczba wystawionych",
            21330
        ],
        [
            "Łódź",
            "Pouczenia: liczba",
            12875
        ],
        [
            "Łódź",
            "Mandaty: wartość",
            2564455
        ],
        [
            "Łódź",
            "Mandaty: liczba wystawionych dot. PRD",
            15264
        ],
        [
            "Łódź",
            "Pouczenia: liczba dot. PRD",
            6414
        ],
        [
            "Łódź",
            "Mandaty: wartość wystawionych dot. PRD",
            2010740
        ],
        [
            "Łódź",
            "Blokady: liczba",
            6404
        ],
        [
            "Łódź",
            "Holowanie: nie-wraki łącznie",
            534
        ],
        [
            "Łódź",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Łódź",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Łódź",
            "Holowanie: DMC",
            null
        ],
        [
            "Łódź",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Łódź",
            "Holowanie: T-24",
            null
        ],
        [
            "Łódź",
            "Holowanie: wraki",
            282
        ],
        [
            "Łódź",
            "Liczba etatów ogółem",
            406
        ],
        [
            "Łódź",
            "Liczba samochodów",
            51
        ],
        [
            "Łódź",
            "Liczba rowerów",
            35
        ],
        [
            "Łódź",
            "Liczba koni",
            8
        ],
        [
            "Łódź",
            "Liczba mieszkańców",
            670642
        ],
        [
            "Opole",
            "Budżet",
            9333324
        ],
        [
            "Opole",
            "Etaty: liczba strażników",
            44
        ],
        [
            "Opole",
            "Etaty: Nieobsadzone wakaty strażników",
            18
        ],
        [
            "Opole",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            7320
        ],
        [
            "Opole",
            "Zgłoszenia: liczba otrzymanych",
            9183
        ],
        [
            "Opole",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            4703
        ],
        [
            "Opole",
            "Interwencje: liczba",
            22872
        ],
        [
            "Opole",
            "Interwencje: liczba dot. PRD",
            9996
        ],
        [
            "Opole",
            "Mandaty: liczba wystawionych",
            2623
        ],
        [
            "Opole",
            "Pouczenia: liczba",
            3640
        ],
        [
            "Opole",
            "Mandaty: wartość",
            239940
        ],
        [
            "Opole",
            "Mandaty: liczba wystawionych dot. PRD",
            1915
        ],
        [
            "Opole",
            "Pouczenia: liczba dot. PRD",
            3117
        ],
        [
            "Opole",
            "Mandaty: wartość wystawionych dot. PRD",
            205890
        ],
        [
            "Opole",
            "Blokady: liczba",
            891
        ],
        [
            "Opole",
            "Holowanie: nie-wraki łącznie",
            129
        ],
        [
            "Opole",
            "Holowanie: utrudnianie ruchu",
            63
        ],
        [
            "Opole",
            "Holowanie: stwarzanie zagrożenia",
            23
        ],
        [
            "Opole",
            "Holowanie: DMC",
            null
        ],
        [
            "Opole",
            "Holowanie: niepełnosprawni",
            4
        ],
        [
            "Opole",
            "Holowanie: T-24",
            39
        ],
        [
            "Opole",
            "Holowanie: wraki",
            26
        ],
        [
            "Opole",
            "Liczba etatów ogółem",
            65
        ],
        [
            "Opole",
            "Liczba samochodów",
            10
        ],
        [
            "Opole",
            "Liczba rowerów",
            8
        ],
        [
            "Opole",
            "Liczba koni",
            null
        ],
        [
            "Opole",
            "Liczba mieszkańców",
            127387
        ],
        [
            "Poznań",
            "Budżet",
            41079987
        ],
        [
            "Poznań",
            "Etaty: liczba strażników",
            248
        ],
        [
            "Poznań",
            "Etaty: Nieobsadzone wakaty strażników",
            14
        ],
        [
            "Poznań",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            6018
        ],
        [
            "Poznań",
            "Zgłoszenia: liczba otrzymanych",
            80037
        ],
        [
            "Poznań",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            46137
        ],
        [
            "Poznań",
            "Interwencje: liczba",
            null
        ],
        [
            "Poznań",
            "Interwencje: liczba dot. PRD",
            null
        ],
        [
            "Poznań",
            "Mandaty: liczba wystawionych",
            51715
        ],
        [
            "Poznań",
            "Pouczenia: liczba",
            4766
        ],
        [
            "Poznań",
            "Mandaty: wartość",
            6330130
        ],
        [
            "Poznań",
            "Mandaty: liczba wystawionych dot. PRD",
            42439
        ],
        [
            "Poznań",
            "Pouczenia: liczba dot. PRD",
            3779
        ],
        [
            "Poznań",
            "Mandaty: wartość wystawionych dot. PRD",
            5305620
        ],
        [
            "Poznań",
            "Blokady: liczba",
            16756
        ],
        [
            "Poznań",
            "Holowanie: nie-wraki łącznie",
            1206
        ],
        [
            "Poznań",
            "Holowanie: utrudnianie ruchu",
            228
        ],
        [
            "Poznań",
            "Holowanie: stwarzanie zagrożenia",
            42
        ],
        [
            "Poznań",
            "Holowanie: DMC",
            null
        ],
        [
            "Poznań",
            "Holowanie: niepełnosprawni",
            77
        ],
        [
            "Poznań",
            "Holowanie: T-24",
            379
        ],
        [
            "Poznań",
            "Holowanie: wraki",
            194
        ],
        [
            "Poznań",
            "Liczba etatów ogółem",
            309
        ],
        [
            "Poznań",
            "Liczba samochodów",
            33
        ],
        [
            "Poznań",
            "Liczba rowerów",
            33
        ],
        [
            "Poznań",
            "Liczba koni",
            null
        ],
        [
            "Poznań",
            "Liczba mieszkańców",
            546859
        ],
        [
            "Szczecin",
            "Budżet",
            18537592
        ],
        [
            "Szczecin",
            "Etaty: liczba strażników",
            118
        ],
        [
            "Szczecin",
            "Etaty: Nieobsadzone wakaty strażników",
            4.75
        ],
        [
            "Szczecin",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            5175
        ],
        [
            "Szczecin",
            "Zgłoszenia: liczba otrzymanych",
            34644
        ],
        [
            "Szczecin",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            13397
        ],
        [
            "Szczecin",
            "Interwencje: liczba",
            44418
        ],
        [
            "Szczecin",
            "Interwencje: liczba dot. PRD",
            39510
        ],
        [
            "Szczecin",
            "Mandaty: liczba wystawionych",
            11992
        ],
        [
            "Szczecin",
            "Pouczenia: liczba",
            4457
        ],
        [
            "Szczecin",
            "Mandaty: wartość",
            2902408
        ],
        [
            "Szczecin",
            "Mandaty: liczba wystawionych dot. PRD",
            11057
        ],
        [
            "Szczecin",
            "Pouczenia: liczba dot. PRD",
            4001
        ],
        [
            "Szczecin",
            "Mandaty: wartość wystawionych dot. PRD",
            2723880
        ],
        [
            "Szczecin",
            "Blokady: liczba",
            3499
        ],
        [
            "Szczecin",
            "Holowanie: nie-wraki łącznie",
            925
        ],
        [
            "Szczecin",
            "Holowanie: utrudnianie ruchu",
            286
        ],
        [
            "Szczecin",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Szczecin",
            "Holowanie: DMC",
            null
        ],
        [
            "Szczecin",
            "Holowanie: niepełnosprawni",
            70
        ],
        [
            "Szczecin",
            "Holowanie: T-24",
            569
        ],
        [
            "Szczecin",
            "Holowanie: wraki",
            260
        ],
        [
            "Szczecin",
            "Liczba etatów ogółem",
            137.25
        ],
        [
            "Szczecin",
            "Liczba samochodów",
            34
        ],
        [
            "Szczecin",
            "Liczba rowerów",
            2
        ],
        [
            "Szczecin",
            "Liczba koni",
            null
        ],
        [
            "Szczecin",
            "Liczba mieszkańców",
            396168
        ],
        [
            "Toruń",
            "Budżet",
            14613400
        ],
        [
            "Toruń",
            "Etaty: liczba strażników",
            106
        ],
        [
            "Toruń",
            "Etaty: Nieobsadzone wakaty strażników",
            9
        ],
        [
            "Toruń",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            7012.4
        ],
        [
            "Toruń",
            "Zgłoszenia: liczba otrzymanych",
            18334
        ],
        [
            "Toruń",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            8331
        ],
        [
            "Toruń",
            "Interwencje: liczba",
            19675
        ],
        [
            "Toruń",
            "Interwencje: liczba dot. PRD",
            13877
        ],
        [
            "Toruń",
            "Mandaty: liczba wystawionych",
            7030
        ],
        [
            "Toruń",
            "Pouczenia: liczba",
            10771
        ],
        [
            "Toruń",
            "Mandaty: wartość",
            920020
        ],
        [
            "Toruń",
            "Mandaty: liczba wystawionych dot. PRD",
            5967
        ],
        [
            "Toruń",
            "Pouczenia: liczba dot. PRD",
            7455
        ],
        [
            "Toruń",
            "Mandaty: wartość wystawionych dot. PRD",
            781770
        ],
        [
            "Toruń",
            "Blokady: liczba",
            2768
        ],
        [
            "Toruń",
            "Holowanie: nie-wraki łącznie",
            13
        ],
        [
            "Toruń",
            "Holowanie: utrudnianie ruchu",
            1
        ],
        [
            "Toruń",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Toruń",
            "Holowanie: DMC",
            null
        ],
        [
            "Toruń",
            "Holowanie: niepełnosprawni",
            6
        ],
        [
            "Toruń",
            "Holowanie: T-24",
            6
        ],
        [
            "Toruń",
            "Holowanie: wraki",
            23
        ],
        [
            "Toruń",
            "Liczba etatów ogółem",
            125.25
        ],
        [
            "Toruń",
            "Liczba samochodów",
            null
        ],
        [
            "Toruń",
            "Liczba rowerów",
            null
        ],
        [
            "Toruń",
            "Liczba koni",
            null
        ],
        [
            "Toruń",
            "Liczba mieszkańców",
            198273
        ],
        [
            "Warszawa",
            "Budżet",
            260599049
        ],
        [
            "Warszawa",
            "Etaty: liczba strażników",
            1271.5
        ],
        [
            "Warszawa",
            "Etaty: Nieobsadzone wakaty strażników",
            292
        ],
        [
            "Warszawa",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            8020
        ],
        [
            "Warszawa",
            "Zgłoszenia: liczba otrzymanych",
            410120
        ],
        [
            "Warszawa",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            210112
        ],
        [
            "Warszawa",
            "Interwencje: liczba",
            null
        ],
        [
            "Warszawa",
            "Interwencje: liczba dot. PRD",
            null
        ],
        [
            "Warszawa",
            "Mandaty: liczba wystawionych",
            101096
        ],
        [
            "Warszawa",
            "Pouczenia: liczba",
            51543
        ],
        [
            "Warszawa",
            "Mandaty: wartość",
            16907646
        ],
        [
            "Warszawa",
            "Mandaty: liczba wystawionych dot. PRD",
            81566
        ],
        [
            "Warszawa",
            "Pouczenia: liczba dot. PRD",
            33159
        ],
        [
            "Warszawa",
            "Mandaty: wartość wystawionych dot. PRD",
            14479089
        ],
        [
            "Warszawa",
            "Blokady: liczba",
            8523
        ],
        [
            "Warszawa",
            "Holowanie: nie-wraki łącznie",
            14840
        ],
        [
            "Warszawa",
            "Holowanie: utrudnianie ruchu",
            5398
        ],
        [
            "Warszawa",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Warszawa",
            "Holowanie: DMC",
            null
        ],
        [
            "Warszawa",
            "Holowanie: niepełnosprawni",
            1204
        ],
        [
            "Warszawa",
            "Holowanie: T-24",
            8238
        ],
        [
            "Warszawa",
            "Holowanie: wraki",
            1642
        ],
        [
            "Warszawa",
            "Liczba etatów ogółem",
            1616
        ],
        [
            "Warszawa",
            "Liczba samochodów",
            260
        ],
        [
            "Warszawa",
            "Liczba rowerów",
            127
        ],
        [
            "Warszawa",
            "Liczba koni",
            null
        ],
        [
            "Warszawa",
            "Liczba mieszkańców",
            1860281
        ],
        [
            "Zielona Góra",
            "Budżet",
            412650
        ],
        [
            "Zielona Góra",
            "Etaty: liczba strażników",
            14
        ],
        [
            "Zielona Góra",
            "Etaty: Nieobsadzone wakaty strażników",
            null
        ],
        [
            "Zielona Góra",
            "Etaty: Mediana wynagrodzeń strażników brutto",
            7395.53
        ],
        [
            "Zielona Góra",
            "Zgłoszenia: liczba otrzymanych",
            3104
        ],
        [
            "Zielona Góra",
            "Zgłoszenia: liczba otrzymanych dot. PRD",
            1157
        ],
        [
            "Zielona Góra",
            "Interwencje: liczba",
            4034
        ],
        [
            "Zielona Góra",
            "Interwencje: liczba dot. PRD",
            null
        ],
        [
            "Zielona Góra",
            "Mandaty: liczba wystawionych",
            59
        ],
        [
            "Zielona Góra",
            "Pouczenia: liczba",
            318
        ],
        [
            "Zielona Góra",
            "Mandaty: wartość",
            11700
        ],
        [
            "Zielona Góra",
            "Mandaty: liczba wystawionych dot. PRD",
            8
        ],
        [
            "Zielona Góra",
            "Pouczenia: liczba dot. PRD",
            143
        ],
        [
            "Zielona Góra",
            "Mandaty: wartość wystawionych dot. PRD",
            1650
        ],
        [
            "Zielona Góra",
            "Blokady: liczba",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: nie-wraki łącznie",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: utrudnianie ruchu",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: stwarzanie zagrożenia",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: DMC",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: niepełnosprawni",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: T-24",
            null
        ],
        [
            "Zielona Góra",
            "Holowanie: wraki",
            54
        ],
        [
            "Zielona Góra",
            "Liczba etatów ogółem",
            14
        ],
        [
            "Zielona Góra",
            "Liczba samochodów",
            3
        ],
        [
            "Zielona Góra",
            "Liczba rowerów",
            2
        ],
        [
            "Zielona Góra",
            "Liczba koni",
            null
        ],
        [
            "Zielona Góra",
            "Uwagi",
            "Dopytałem o budżet i średnie wynagrodzenie 26.11"
        ],
        [
            "Zielona Góra",
            "Liczba mieszkańców",
            140002
        ]
    ],
    "research": [
        {
            "city": "Szczecin",
            "count": 1085,
            "area": "Śródmieście",
            "residentPercent": 15,
            "source": "Szczecin Polityka Parkingowa etap I, s. 35, 49"
        },
        {
            "city": "Kielce",
            "count": 743,
            "area": "SPP oraz obszar przyległy (Sektory 1, 2, 3)",
            "residentPercent": 10,
            "source": "Polityka parkingowa - raport główny, s. 21, 55"
        },
        {
            "city": "Łódź",
            "count": 2337,
            "area": "SPP",
            "residentPercent": 15,
            "source": "Sprawozdanie z Badania SPP w Łodzi, s. 45"
        },
        {
            "city": "Gorzów",
            "count": 555,
            "area": "Obecna i planowana SPP",
            "residentPercent": 8,
            "source": "Gorzów badanie.pdf, s. 102, 106"
        },
        {
            "city": "Rzeszów",
            "count": 301,
            "area": "SPP",
            "residentPercent": 5,
            "source": "Analiza funkcjonowania SPP, s. 30"
        },
        {
            "city": "Poznań",
            "count": 119,
            "area": "Fragment SPP na Jeżycach",
            "residentPercent": 1,
            "source": "180820 Opracowanie końcowe v. 1.0.pdf, s. 9"
        },
        {
            "city": "Warszawa",
            "count": 1127,
            "area": "Południowa część dzielnicy Mokotów",
            "residentPercent": 3,
            "source": "Raport Warszawa Mokotow strefa2.pdf, s. 15"
        }
    ]
}